import { createFileRoute } from '@tanstack/react-router';
import LogTemplateEdit from '../../../features/baseData/logTemplates/logTemplate/edit';
import {
  createPermissionGuard,
  getPermissionSet,
  LOG_TEMPLATES_PERMISSIONS,
} from '@bmwe/ui';

export const Route = createFileRoute(
  '/stammdaten/verfuegungsvorlagen/$logTemplateId_/bearbeiten',
)({
  component: LogTemplateEdit,
  beforeLoad: createPermissionGuard(
    getPermissionSet(LOG_TEMPLATES_PERMISSIONS, 'EDIT'),
  ),
});

export const EditLogTemplateRoute = Route;
